import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import withMobileDialog from "@material-ui/core/withMobileDialog"
import LoadingButton from "../../components/LoadingButton"
import TwitterIcon from "@material-ui/icons/Twitter"
import { uploadFile } from "../../actions/misc"
import Grid from "@material-ui/core/Grid"
import { isEmpty, pickBy, find } from "lodash"
import Button from "@material-ui/core/Button"
import { DialogTitle } from "@material-ui/core"
import update from "immutability-helper"
import { openSnackBar } from "../../actions/snack-bar"
import {
  toggleEditCompanyDialog,
  updateCompany,
  _updateCompany,
  addManager,
  removeManager,
} from "../../actions/companies"
import Paper from "@material-ui/core/Paper"
import Avatar from "@material-ui/core/Avatar"
import Input from "@material-ui/core/Input"
import FormControl from "@material-ui/core/FormControl"
import AddIcon from "@material-ui/icons/Add"
import Typography from "@material-ui/core/Typography"
import CircularProgress from "@material-ui/core/CircularProgress"
import AddPhotoAlternate from "@material-ui/icons/AddAPhoto"
import { createUser, getUserByPhone } from "../../actions/users"
import phoneFns from "phone-fns"
import CircleAvatar from "../CircleAvatar/index"
import CancelIcon from "@material-ui/icons/Cancel"
import AddressAutoComplete from "../AddressAutoComplete/index"
import PhoneInput from "../PhoneInput/index"
import { Chip } from "@material-ui/core"
import InputLabel from "@material-ui/core/InputLabel"
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from "@material-ui/core"
import classNames from "classnames"
import { handleConnect } from "../../utils/handleSocialConnect"
import Badge from "@material-ui/core/Badge"

const phoneLib = phoneFns()
class EditCompanyDialogComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      company: {
        name: "",
        phone: "",
        email: "",
        route: "",
        street_number: "",
        city: "",
        state: "",
        zip: "",
        lat: "",
        lon: "",
      },
      showEnterNameDialog: false,
      foundUser: {},
      organizerFirstName: "",
      organizerLastName: "",
      organizerPhone: "",
      newShootField: "",
    }
  }
  handleClose = () => {
    this.props.dispatch(toggleEditCompanyDialog())
  }
  setValues = () => {
    let newState = update(this.state, {})
    if (!isEmpty(this.props.company)) {
      const {
        name,
        formattedPhone: phone,
        email,
        route,
        street_number,
        city,
        state,
        zip,
        lat,
        lon,
      } = this.props.company
      newState = {
        ...newState,
        company: {
          name,
          phone,
          email,
          route,
          street_number,
          city,
          state,
          zip,
          lat,
          lon,
        },
      }
    }
    this.setState(newState)
  }
  clearState = () => {
    this.setState({
      company: {
        name: "",
        phone: "",
        email: "",
        route: "",
        street_number: "",
        city: "",
        state: "",
        zip: "",
        lat: "",
        lon: "",
      },
      countryCode: "US",
      showEnterNameDialog: false,
      foundUser: {},
      organizerFirstName: "",
      organizerLastName: "",
      organizerPhone: "",
    })
  }
  handleInputChange = e => {
    const fieldName = e.target.name
    const value = e.target.value

    let newState = update(this.state, {
      company: {
        [fieldName]: { $set: value },
      },
    })
    this.setState(newState)
  }
  handleCountryChange = country => {
    this.setState({ countryCode: country })
  }
  handleOrganizerPhoneChange = value => {
    this.setState(
      update(this.state, {
        organizerPhone: {
          $set: value,
        },
      })
    )
  }

  handleNewShootFieldChange = e => {
    const value = e.target.value
    this.setState(
      update(this.state, {
        newShootField: {
          $set: value,
        },
      })
    )
  }
  handleNameInputChange = e => {
    const fieldName = e.target.name
    const value = e.target.value

    let newState = update(this.state, {
      [fieldName]: { $set: value },
    })
    this.setState(newState)
  }
  onAddressChange = place => {
    let updates = {}
    for (const key in place) {
      updates[key] = {
        $set: place[key] || "",
      }
    }
    this.setState(
      update(this.state, {
        company: {
          ...updates,
        },
      })
    )
  }
  getDiff = () =>
    pickBy(this.state.company, (val, key) => val !== this.props.company[key])
  submit = e => {
    if (e) {
      e.preventDefault()
    }
    this.setState({
      savingCompany: true,
    })
    const updates = this.getDiff()
    this.props
      .dispatch(updateCompany(this.props.company.id, updates))
      .then(res => {
        this.props.dispatch(
          openSnackBar({
            message: "Organization updated",
          })
        )
        this.setState({
          savingCompany: false,
        })
        this.handleClose()
      })
      .catch(err => {
        console.log(err)
        this.setState({
          savingCompany: false,
        })
        this.props.dispatch(
          openSnackBar({
            message: "There was an error updating this organization",
          })
        )
      })
  }
  logoChanged = e => {
    const file = e.target.files[0]
    this.setState({ uploadingLogo: true })
    this.props
      .dispatch(
        uploadFile(file, `companies/${this.props.company.id}/logo_images`)
      )
      .then(image => {
        this.props
          .dispatch(
            updateCompany(this.props.company.id, {
              logo_image: JSON.stringify(image),
            })
          )
          .then(res => {
            this.props.dispatch(
              _updateCompany({
                id: this.props.company.id,
                logo_image: image,
              })
            )
            this.props.dispatch(
              openSnackBar({
                message: "Logo saved",
              })
            )
            this.setState({ uploadingLogo: false })
            document.getElementById("companyLogo").value = ""
          })
          .catch(err => {
            this.props.dispatch(
              openSnackBar({
                message: "There was an error saving logo",
              })
            )
            this.setState({ uploadingLogo: false })
            document.getElementById("companyLogo").value = ""
          })
      })
      .catch(err => {
        this.setState({ uploadingLogo: false })
        document.getElementById("companyLogo").value = ""
        this.props.dispatch(
          openSnackBar({
            message: "There was an error saving logo",
          })
        )
      })
  }
  saveManager = userId => {
    this.props
      .dispatch(addManager(this.props.company.id, userId))
      .then(res => {
        const {
          first_name,
          last_name,
          profile_image,
          id,
          phone,
          email,
        } = this.state.foundUser
        this.props.dispatch(
          _updateCompany({
            id: this.props.company.id,
            managers: [
              ...this.props.company.managers,
              {
                first_name,
                last_name,
                profile_image,
                id,
                phone,
                email,
              },
            ],
          })
        )
        this.setState({
          addingManager: false,
          organizerFirstName: "",
          organizerLastName: "",
          organizerPhone: "",
        })
        this.props.dispatch(
          openSnackBar({
            message: "Manager added to organization",
          })
        )
      })
      .catch(err => {
        this.props.dispatch(
          openSnackBar({
            message: "There was an error adding manager",
          })
        )
        this.setState({
          addingManager: false,
          organizerFirstName: "",
          organizerLastName: "",
          organizerPhone: "",
        })
      })
  }
  createUser = () => {
    this.setState({
      showEnterNameDialog: false,
    })
    this.props
      .dispatch(
        createUser({
          phone: phoneLib.uglify(this.state.organizerPhone),
          first_name: this.state.organizerFirstName,
          last_name: this.state.organizerLastName,
          countryCode: this.state.countryCode,
        })
      )
      .then(res => {
        this.setState({ foundUser: res })
        this.saveManager(res.id)
      })
      .catch(err => {
        let message = "There was an error adding manager"
        if (err.response) {
          if (err.response.body.message === "twilio create sms error") {
            message = "That number is not a valid number"
          }
        }
        this.props.dispatch(
          openSnackBar({
            message,
          })
        )
        this.setState({ addingManager: false })
      })
  }
  saveOrganizer = () => {
    this.setState({ addingManager: true })
    this.props
      .dispatch(getUserByPhone(this.state.organizerPhone))
      .then(res => {
        this.setState({ foundUser: res })
        this.saveManager(res.id)
      })
      .catch(err => {
        if (err.status === 404) {
          this.setState({ showEnterNameDialog: true })
        } else {
          this.setState({ addingManager: false })
          this.props.dispatch(
            openSnackBar({
              message: "There was an unknown error",
            })
          )
        }
      })
  }

  saveNewShootField = () => {
    this.setState({ savingNewShootFlied: true })
    const { company } = this.props
    const { newShootField } = this.state

    let shootFields
    shootFields = company.shoot_fields ? JSON.parse(company.shoot_fields) : []
    if (
      !isEmpty(shootFields) &&
      !isEmpty(find(shootFields, field => field === newShootField))
    ) {
      this.props.dispatch(
        openSnackBar({ message: "Shoot Field Already Exists" })
      )
      this.setState({ savingNewShootFlied: false })
      return
    }
    shootFields.push(newShootField)

    let updates = null
    updates = { shoot_fields: JSON.stringify(shootFields) }

    this.props
      .dispatch(updateCompany(company.id, updates))
      .then(res => {
        this.props.dispatch(openSnackBar({ message: "Shoot Field Added" }))
        this.props.dispatch(
          _updateCompany({
            id: this.props.company.id,
            shoot_fields: JSON.stringify(shootFields),
          })
        )
        this.setState({ savingNewShootFlied: false, newShootField: "" })
      })
      .catch(err => {
        this.props.dispatch(
          openSnackBar({
            message: "There was an error adding the shoot field",
          })
        )
        this.setState({ savingNewShootFlied: false })
      })
  }

  onDeleteShootField = fieldIndex => {
    const { company } = this.props

    let shootFields = []

    shootFields = JSON.parse(company.shoot_fields)
    shootFields.splice(fieldIndex, 1)
    let updates = null

    updates = { shoot_fields: JSON.stringify(shootFields) }

    this.props
      .dispatch(updateCompany(company.id, updates))
      .then(res => {
        this.props.dispatch(openSnackBar({ message: "Field Deleted" }))
        this.props.dispatch(
          _updateCompany({
            id: this.props.company.id,
            shoot_fields: JSON.stringify(shootFields),
          })
        )
      })
      .catch(err => {
        this.props.dispatch(
          openSnackBar({
            message: "There was an error deleting the shoot field",
          })
        )
      })
  }

  handleEnterNameDialogClose = () => {
    this.setState({
      addingManager: false,
      showEnterNameDialog: false,
      foundUser: {},
      organizerFirstName: "",
      organizerLastName: "",
    })
  }
  removeManager = manager => {
    this.props
      .dispatch(removeManager(this.props.company.id, manager.id))
      .then(res => {
        this.props.dispatch(
          _updateCompany({
            id: this.props.company.id,
            managers: this.props.company.managers.filter(
              m => m.id !== manager.id
            ),
          })
        )
        this.props.dispatch(
          openSnackBar({
            message: "Manager Removed",
          })
        )
      })
  }

  generateLogo = () => {
    if (!isEmpty(this.props.company)) {
      if (!isEmpty(this.props.company.logo_image)) {
        return (
          <img
            className={this.props.classes.logoImage}
            src={`https://res.cloudinary.com/${
              process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
            }/image/upload/c_thumb,h_400,w_400,fl_lossy,f_auto/v${
              this.props.company.logo_image.version
            }/${this.props.company.logo_image.public_id}.${
              this.props.company.logo_image.format
            }`}
            alt={`${this.props.company.first_name} ${
              this.props.company.last_name
            }`}
          />
        )
      } else {
        return (
          <Avatar className={this.props.classes.logo}>
            {this.props.company.name.charAt(0)}
          </Avatar>
        )
      }
    }
  }

  handleSocialConnectSwitch = (e, network, networkId) => {
    const data = {
      company_id: this.props.company.id,
      network_id: networkId,
    }

    handleConnect(network, this.props.authenticatedUser.id, data)
  }
  render() {
    console.log("what u need", this.props)
    console.log("state", this.state)
    const {
      fullScreen,
      classes,
      company,
      networks,
      authenticatedUser,
    } = this.props

    return (
      <Fragment>
        <Dialog
          className={classes.enterNameDialog}
          fullScreen={fullScreen}
          open={this.state.showEnterNameDialog}
        >
          <DialogContent>
            <Typography variant="h6">Enter Manager Name</Typography>
            <Grid container spacing={4}>
              <Grid item xs={6}>
                <FormControl fullWidth className={classes.marginBottom}>
                  <Input
                    type="text"
                    fullWidth
                    name="organizerFirstName"
                    placeholder="Manager First Name"
                    value={this.state.organizerFirstName}
                    onChange={this.handleNameInputChange}
                    id="organizerFirstName"
                    autoComplete="nope"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth className={classes.marginBottom}>
                  <Input
                    type="text"
                    fullWidth
                    name="organizerLastName"
                    placeholder="Manager Last Name"
                    value={this.state.organizerLastName}
                    onChange={this.handleNameInputChange}
                    id="organizerLastName"
                    autoComplete="nope"
                  />
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions
            className={classes.dialogActions}
            classes={{
              action: classes.dialogActionsAction,
            }}
          >
            <Button
              className={classes.cancelButton}
              onClick={this.handleEnterNameDialogClose}
              type="button"
            >
              Cancel
            </Button>
            <LoadingButton
              color="secondary"
              buttonclicked={this.createUser}
              disabled={
                !this.state.organizerFirstName || !this.state.organizerLastName
              }
              type="button"
            >
              Save
            </LoadingButton>
          </DialogActions>
        </Dialog>
        <Dialog
          className={classes.editCompanyDialog}
          fullScreen={fullScreen}
          open={this.props.editCompanyDialogOpen}
          onClose={this.handleClose}
          onEntering={this.setValues}
          onExited={this.clearState}
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            classes: {
              root: classes.dialogPaper,
            },
          }}
        >
          <DialogTitle className={classes.dialogTitle}>
            <Typography variant="h6">
              {this.state.company && this.state.company.name}
            </Typography>
          </DialogTitle>
          {!isEmpty(this.props.company) && (
            <form onSubmit={this.submit} autoComplete="off">
              <DialogContent className={classes.dialogContent}>
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={4}>
                    <Paper eleation={2} className={classes.logoPaper}>
                      <div className={classes.logoWrapper}>
                        {this.state.uploadingLogo && (
                          <div className={classes.logoUploadOverlay}>
                            <CircularProgress
                              color="inherit"
                              className={classes.logoUploadProgress}
                            />
                          </div>
                        )}
                        <label
                          htmlFor="companyLogo"
                          className={classes.logoLabel}
                        >
                          {!this.state.uploadingLogo && (
                            <div className={classes.addImageOverlay}>
                              <AddPhotoAlternate
                                className={classes.addPhotoIcon}
                              />
                            </div>
                          )}
                          {this.generateLogo()}
                          <input
                            type="file"
                            id="companyLogo"
                            name="companyLogo"
                            className={classes.logoInput}
                            value={this.state.companyLogo}
                            onChange={this.logoChanged}
                          />
                        </label>
                      </div>
                    </Paper>
                    <FormControl fullWidth className={classes.marginBottom}>
                      <Input
                        type="text"
                        fullWidth
                        name="name"
                        placeholder="Organization Name"
                        value={this.state.company.name}
                        onChange={this.handleInputChange}
                        id="name"
                        autoComplete="nope"
                      />
                    </FormControl>
                    <PhoneInput
                      name="phone"
                      value={this.state.company.phone}
                      onChange={this.handleInputChange}
                    />
                    <FormControl fullWidth className={classes.marginBottom}>
                      <Input
                        type="email"
                        fullWidth
                        name="email"
                        placeholder="Email"
                        value={this.state.company.email}
                        onChange={this.handleInputChange}
                        id="email"
                        autoComplete="nope"
                      />
                    </FormControl>
                    <AddressAutoComplete
                      className={classes.autoComplete}
                      value={
                        this.state.company.street_number
                          ? `${this.state.company.street_number} ${
                              this.state.company.route
                            } ${this.state.company.city}, ${
                              this.state.company.state
                            } ${this.state.company.zip}`
                          : undefined
                      }
                      InputProps={{ label: "Enter Organization Address" }}
                      InputClasses={{
                        input: classes.placesAutoCompleteInputInput,
                      }}
                      onChange={this.onAddressChange}
                    />
                    {/* social connect start */}
                    {networks &&
                      networks.length > 0 && (
                        <Fragment>
                          <div
                            className={classNames(
                              classes.headlineWrapper,
                              classes.marginTop4
                            )}
                          >
                            <Typography
                              variant="h5"
                              className={classes.socialHeadline}
                            >
                              Linked Accounts
                            </Typography>
                          </div>
                          {!this.props.company.twitter && (
                            <div className={classes.socialSwitchWrapper}>
                              <TwitterIcon />
                              <Button
                                color="primary"
                                type="button"
                                onClick={event =>
                                  this.handleSocialConnectSwitch(
                                    event,
                                    "twitter",
                                    1
                                  )
                                }
                              >
                                Link Twitter
                              </Button>
                            </div>
                          )}
                          {this.props.company.twitter && (
                            // networks.map((network, networkIndex) => {
                            // if (network.id)
                            // return (
                            <div className={classes.switchWrapper}>
                              <TwitterIcon className={classes.twitterIcon} />
                              <Typography
                                variant="p"
                                className={classes.socialHeadline}
                              >
                                @{
                                  JSON.parse(this.props.company.twitter)
                                    .screen_name
                                }
                              </Typography>
                            </div>
                          )}

                          {/* {this.state.company.twitter && (
                            <div className={classes.switchWrapper}>
                              <TwitterIcon className={classes.twitterIcon} />
                              <Typography
                                variant="p"
                                className={classes.socialHeadline}
                              >
                                @{
                                  JSON.parse(this.state.company.twitter)
                                    .screen_name
                                }
                              </Typography>
                            </div>
                          )} */}
                        </Fragment>
                      )}

                    {/* social connect end */}
                  </Grid>

                  <Grid item xs={12} sm={8}>
                    {/* {accessLevel === 1 && (
                      // activeCompany !== 2 &&
                      // activeCompany !== 3 &&
                      <CompanyShootFieldsBar />
                    )} */}
                    {/* </Grid> */}

                    <div className={classes.headlineWrapper}>
                      <Typography variant="h2" className={classes.headline}>
                        Shoot Details Fields
                      </Typography>
                    </div>

                    <Grid>
                      {this.props.company &&
                        JSON.parse(this.props.company.shoot_fields).map(
                          (field, index) => (
                            <Chip
                              label={field}
                              className={this.props.classes.chip}
                              classes={{
                                deleteIcon: this.props.classes.chipDeleteIcon,
                              }}
                              deleteIcon={
                                <CancelIcon
                                // onTouchEnd={() =>
                                //   this.onDeleteShootField(index)
                                // }
                                />
                              }
                              onDelete={() => this.onDeleteShootField(index)}
                            />
                          )
                        )}
                    </Grid>

                    <div className={classes.inputWithAddButton}>
                      <div className={classes.newInputWrapper}>
                        <FormControl fullWidth>
                          <InputLabel htmlFor="description">
                            New {this.state.company && this.state.company.name}{" "}
                            Field
                          </InputLabel>
                          <Input
                            fullWidth
                            classes={{
                              input: classes.input,
                            }}
                            name="newShootField"
                            value={this.state.newShootField}
                            onChange={this.handleNewShootFieldChange}
                          />
                        </FormControl>
                      </div>
                      <LoadingButton
                        color="primary"
                        size="small"
                        buttonclicked={this.saveNewShootField}
                        working={this.state.savingNewShootFlied}
                        disabled={!this.state.newShootField}
                        type="button"
                      >
                        <AddIcon color="inherit" />
                      </LoadingButton>
                    </div>

                    <div className={classes.headlineWrapper}>
                      <Typography variant="h2" className={classes.headline}>
                        Users
                      </Typography>
                    </div>

                    {authenticatedUser.super_admin === 1 && (
                      <div className={classes.inputWithAddButton}>
                        <div className={classes.newInputWrapper}>
                          <PhoneInput
                            name="organizerPhone"
                            value={this.state.organizerPhone}
                            onChange={this.handleOrganizerPhoneChange}
                            onCountryChange={this.handleCountryChange}
                          />
                        </div>

                        <LoadingButton
                          color="primary"
                          size="small"
                          buttonclicked={this.saveOrganizer}
                          working={this.state.addingManager}
                          disabled={!this.state.organizerPhone}
                          type="button"
                        >
                          <AddIcon color="inherit" />
                        </LoadingButton>
                      </div>
                    )}

                    {this.props.company.managers.map(manager => (
                      <ExpansionPanel
                        key={manager.id}
                        className={classes.collapseStyles}
                      >
                        <ExpansionPanelSummary
                          style={{ justifyContent: "space-between", margin: 0 }}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <div className={classes.manager}>
                            <div className={classes.managerContent}>
                              <Typography
                                compontent="span"
                                className={classes.managerSecondLine}
                              >
                                {manager.first_name} {manager.last_name}{" "}
                                {manager.email} / {manager.phone}
                                {manager.super_admin && (
                                  <Badge
                                    variant="dot"
                                    color="primary"
                                    style={{
                                      transform: "translate(5px, -10px)",
                                    }}
                                  />
                                )}
                              </Typography>
                            </div>
                            <div className={classes.managerAvatarWrapper}>
                              <CircleAvatar
                                className={classes.circleAvatar}
                                image={manager.profile_image}
                              >
                                {manager.first_name.charAt(0)}
                                {manager.last_name.charAt(0)}
                              </CircleAvatar>
                            </div>
                          </div>
                        </ExpansionPanelSummary>

                        <ExpansionPanelDetails
                          style={{ paddingTop: "0px", paddingBottom: "0px" }}
                        >
                          <div className={classes.manager}>
                            <Typography
                              compontent="span"
                              className={classes.designationText}
                            >
                              Admin
                            </Typography>
                            <Typography
                              compontent="span"
                              className={classes.activeCompanyText}
                            >
                              {this.state.company && this.state.company.name}
                            </Typography>
                          </div>
                          <div>
                            <Button
                              className={classes.actionText}
                              onClick={() => this.removeManager(manager)}
                            >
                              Remove
                            </Button>
                          </div>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                    ))}
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions className={classes.dialogActions}>
                <Button
                  className={classes.cancelButton}
                  onClick={this.handleClose}
                  type="button"
                >
                  Close
                </Button>
                <LoadingButton
                  // className={classes.saveButton}
                  color="primary"
                  buttonclicked={this.submit}
                  working={this.state.savingCompany}
                  disabled={
                    (!isEmpty(company)
                      ? isEmpty(this.getDiff())
                      : !isEmpty(this.state.form) && !this.state.form.valid) ||
                    this.state.savingAndCloseCompany
                  }
                  type="button"
                >
                  Save
                </LoadingButton>
              </DialogActions>
            </form>
          )}
        </Dialog>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticatedUser: state.authentication.authenticatedUser,
    companyShootField: state.companies.companyShootFields,
    editCompanyDialogOpen: state.companies.editCompanyDialogOpen,
    company: state.companies.editCompany,
    accessLevel: state.companies.accessLevel,
    activeCompany: state.companies.activeCompany,
    networks: state.misc.networks,
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true }),
  withMobileDialog()
)(EditCompanyDialogComponent)
